import React from 'react';
import CategoryDescriptionComponent, { type CategoryDescriptionComponentProps } from 'content/CategoryDescription';

interface CategoryDescriptionBlockProps {
    data: CategoryDescriptionComponentProps;
}

const CategoryDescriptionBlock: React.FC<CategoryDescriptionBlockProps> = ({ data }) => (
    <CategoryDescriptionComponent {...data} />
);
export default CategoryDescriptionBlock;
